import React from "react";
import "./BoardsDetailTabPanel.css";

const BoardsDetailTabPanel = ({ children }) => {
  return (
    <section className="boardsDetailPanel">
      <div className="boardsDetailPanel-inner">{children}</div>
    </section>
  );
};

export default BoardsDetailTabPanel;
